import { RowType } from "@components/molecules/DynamicForm/types";
import * as yup from "yup";

export const generateYupSchema = (formStructure: RowType[], t: any) => {
  const schemaObject: { [key: string]: yup.Schema<any> } = {};

  formStructure.forEach((field) => {
    let fieldSchema: yup.Schema<any>;
    switch (field.type) {
      case "dropdown":
        fieldSchema = yup
          .string()
          .oneOf(field.options?.map((option) => option.value) || []);
        break;
      default:
        fieldSchema = yup.string();
    }

    if (field.validations) {
      const { required, min, max, regex, errorMessage } = field.validations;

      if (required) {
        fieldSchema = fieldSchema.required(t(errorMessage));
      }

      if (min !== undefined) {
        fieldSchema = fieldSchema.min(min, t(errorMessage));
      }

      if (max !== undefined) {
        fieldSchema = fieldSchema.max(max, t(errorMessage));
      }

      if (regex) {
        fieldSchema = fieldSchema.matches(
          new RegExp(regex.pattern, regex.flags),
          t(errorMessage)
        );
      }
    }

    if (field.name === "engrave_text") {
      fieldSchema = fieldSchema.test(
        "engrave-font-required",
        t(
          "productDetailPage.personalization.errors.engraveFontRequired.text",
          "Please select an engrave font."
        ),
        function (value) {
          const { engrave_font } = this.parent;
          if (value && value.trim().length > 0) {
            return engrave_font && engrave_font.trim().length > 0;
          }
          return true;
        }
      );
    }

    schemaObject[field.name] = fieldSchema;
  });

  return yup.object().shape(schemaObject);
};

export const onChangeValue = (
  field: RowType,
  val: string,
  onChange: (value: string) => void
) => {
  if (field.name === "engrave_text") {
    const maxLength =
      (field.validations as any)?.maxLength ?? field.characterLimit;
    if (!maxLength || val.length <= maxLength) {
      onChange(val);
    }
    return;
  }
  onChange(val);
};

export function dynamicMapToRowType<T extends object>(
  field: Record<string, any>
): Partial<T> {
  const mappedObject = {} as Partial<T>;

  (Object.keys(field) as (keyof T)[]).forEach((key) => {
    mappedObject[key] = field[key];
  });

  return mappedObject;
}

export const hasRequiredFields = (
  obj: Record<string, any>,
  requiredFields: string[]
): boolean => {
  return requiredFields.every((field) => {
    const value = obj[field];
    return typeof value === "string" ? value.trim().length > 0 : !!value;
  });
};
